class LocationDialog extends HTMLDialogElement {
  constructor() {
    super();

    this.blockId = this.id;

    if (document.cookie.indexOf(`popupClosed-${ this.blockId }=true`) === -1) {
      this.currentLocationCountry = this.dataset.currentLocationCountry;
      this.targetCountries = this.dataset.locationTargetCountries.split(',');

      this.closeButton = this.querySelector('[data-location-close]');
  
      if (this.targetCountries.includes(this.currentLocationCountry)) {
        this.showModal();
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);
        document.cookie = `popupClosed-${ this.blockId }=true; expires=` + expirationDate.toUTCString();
      }
      
      this.closeButton.addEventListener('click', e => {
        this.close();
      });
  
      this.addEventListener('click', e => {
        const dialogDimensions = this.getBoundingClientRect()
        if (
          e.clientX < dialogDimensions.left ||
          e.clientX > dialogDimensions.right ||
          e.clientY < dialogDimensions.top ||
          e.clientY > dialogDimensions.bottom
        ) {
          this.close()
        }
      });
    }
  }
}

customElements.define('location-dialog', LocationDialog, {extends: 'dialog'});